"use client";
import { useEffect, useState } from "react";
import FileUploader from "../../../components/common/FileUploader";
import SelectInput from "../../../components/Select";
import { useFetchCountriesAllData, useFetchCountryHubsAllData } from "../../../apis/locationApis";
import Input from "../../../components/Input";

export const SystemTypes = [
  { value: "phone", text: "Phone" },
  { value: "email", text: "Email" },
  { value: "whatsapp", text: "WhatsApp" },
];

type Props= {
  register: any;
  errors: any;
  watch: any;
}

const AddCitiesModal = ({ register, errors, watch } : Props) => {
  const [selectedCountryId, setSelectedCountryId] = useState('')

  const { data, refetch } = useFetchCountriesAllData();

  const { data: hubs, refetch: fetchData } = useFetchCountryHubsAllData(selectedCountryId);
  
  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (selectedCountryId) {
      fetchData();
    }
  }, [selectedCountryId]);

  return (
    <div className="w-[655px] p-4 space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <SelectInput
          name="countryId"
          label="Country Name"
          placeholder="Select Country"
          selectOptions={
            data?.map((country: any) => ({
              id: country?.id,
              value: country?.id,
              text: country?.name,
            })) || []
          }
          register={register}
          validation={{ required: "Country is required" }}
          error={errors.countryId}
          disabled={!data || data.length === 0}
          value={selectedCountryId}
          setValue={(val: string) => setSelectedCountryId(val)}
        />

        <Input
          name="name"
          type="text"
          title="City Name"
          placeholder="Riyadh"
          register={register}
          error={errors.name}
          validation={{
            required: "City name is required",
          }}
        />

        <Input
          name="arabicName"
          type="text"
          title="City Arabic Name"
          placeholder="RIY"
          register={register}
          error={errors.arabicName}
          validation={{
            required: "City arabic name is required",
          }}
        />
 
        <Input
          name="cityCode"
          type="text"
          title="City Code"
          placeholder="RY"
          register={register}
          error={errors.cityCode}
          validation={{
            required: "City code is required",
          }}
        />
      </div>
      <div className="bg-white border-l-4 rounded border-[#FBD037] p-2 flex justify-between items-center">
        <p className="text-xs">
          Note: Please upload the file in the same format as the downloaded
          file.{" "}
        </p>
        <button
          className="border border-[#00811D] bg-[#00811D] text-white flex items-center gap-1 rounded-full p-1.5 px-4 text-sm font-medium cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          type="button"
        >
          <img src="/img/csvxl.svg" alt="download" />
          Download
        </button>
      </div>
      <div>
        {/* <FileUploader
          classNameMain="bg-white flex flex-col items-center justify-center"
          title={"Upload CSV File"}
          message={"File Should be CSV "}
          img={"/img/upload-csv.png"}
        /> */}
        <FileUploader
          name="csvFile"
          classNameMain="bg-white flex flex-col items-center justify-center"
          title={"Upload CSV File"}
          message={"File Should be CSV "}
          img={"/img/upload-csv.png"} classNameImgDiv="bg-[#FBD037]/20 "        />
      </div>
    </div>
  );
};

export default AddCitiesModal;
